import '../../picker-view/style/';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/picker/style/index.web.tsx
 **/